export const SINGLE_SITE_USER_TYPE = 'Single-Service-Customer';
export const MULTI_SITE_USER_TYPE = 'Multi-Service-Customer';

export const userRoles = Object.freeze({
  phAdvanced: 'DATA_VIS_ACC_ADV',
  tcAdvanced: 'TCADV',
  publicEvent: 'PUBLIC_EVENT_N_ACTIVITIES',
});

export const notServicedErrorMessages = {
  'Not-Serviced': 'We_are_sorry,_we_are_not_giving_any_service_to_you_yet',
  'Not-Serviced(Orgnization Association Pending)':
    'Organization_Association_Pending',
  'Not-Serviced(Orgnization Association Pending Approval)':
    'Organization_Association_Pending_Approval',
  'Not-Serviced(User Role Association Pending - Contact User Administrator)':
    'User_Role_Association Pending_-_Contact_User_Administrator',
  'Not-Serviced(Site Association Pending - Contact User Administrator)':
    'Site_Association_Pending_-_Contact_User_Administrator',
  'Not-Serviced(Your account is being setup please try after some time)':
    'Your_account_is_being_setup,_please_try_after_some_time',
};

export const associationPending =
  'Not-Serviced(Orgnization Association Pending)';

export const enableAppRestrictionPaiPortal = true;
export const localStorageAllowedApps = 'allowedApps';

export const applicationCode = {
  pai: 'PAI',
  liveConnect: 'Live Connect',
  digitalService: 'Digital Service',
  tc: 'TC',
};

export const applicationUrls = {
  'Live Connect': '/liveConnect/search',
  'Digital Service': '/ds/home',
};

export const privacyNoticeURL =
  'https://www.corporate.carrier.com/legal/privacy-notice/';

export const enableFeatures = { trendsCSVDownload: true };

export const INFO_ALLOWED_FOR_PAGES = [
  'Live Connect',
  'To do list',
  'Site Summary',
  'Equipment Details',
];

export const allEquipCategory = 'ALL';

export const DEFAULT_METRICS = Object.freeze({
  NUMBER_VIEW: 'numberView',
  PERCENTAGE_VIEW: 'percentageView',
});

export const defaultMetricsOptions = [
  { key: DEFAULT_METRICS.NUMBER_VIEW, value: 'Number_view_hash' },
  { key: DEFAULT_METRICS.PERCENTAGE_VIEW, value: 'Percentage_view_percent' },
];
